/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPotluckDinnerTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPotluckDinner,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Feast Together!",
    "Foodie Friends Unite!",
    "Bring Your Best Dish!",
  ],
  title: "Potluck Dinner",
  description: "Organize a delicious potluck dinner.",
  longDescription:
    "Gather your friends for a fun potluck dinner! Choose a date, coordinate dishes, and ensure everyone brings something tasty to share!",
  emoji: "🍽",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Potluck Dinner",
          emoji: "🍽",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the potluck dinner?",
          emoji: "📅",
          completeAction: {
            question: "Decide on dishes to bring?",
            description: "What dishes should we all contribute?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What dishes should we bring?",
                emoji: "🥘",
                completeAction: {
                  question: "Decide on drinks?",
                  description: "What drinks should we provide for the potluck?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "🍷",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Delicious Plans Ahead!",
    outroDescription:
      "Your potluck dinner plans are set! Enjoy the feast and fun!",
  },
};
